<template>
    <div class="row">
        <div class="col-lg-12 setforsearchbarpanel position-relative innersltpad">
            <div class="searchbar_tops">
                <div class="iq-search-bar device-search">
                <form>
                    <div class="input-prepend input-append">
                    <label class="searchbox">
                        <input
                        class="search-query text search-input"
                        type="text"
                        placeholder="Search in MDrive (Coming Soon) "
                        />
                        <a class="search-link" href="javascript:void(0);">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M16.296 2.043c.407 1.817 1.284 2.716 3.317 3.089.14 0 .255.104.255.233s-.114.233-.255.233c-1.982.373-2.909 1.218-3.315 3.081a.246.246 0 0 1-.243.18.245.245 0 0 1-.245-.191c-.407-1.818-1.28-2.697-3.313-3.07-.14 0-.254-.104-.254-.233s.114-.233.254-.233c1.982-.373 2.91-1.223 3.317-3.087a.247.247 0 0 1 .241-.175c.117 0 .212.074.241.173Z"
                            fill="url(#_3085173834__a)"
                            ></path>
                            <path
                            d="M15.094 17.436A7.5 7.5 0 1 1 10 4.046v1.503A6 6 0 1 0 16.446 11h1.504a7.466 7.466 0 0 1-1.46 5.003l4.25 4.25a1 1 0 0 1-1.414 1.414l-4.232-4.231Z"
                            fill="url(#_3085173834__b)"
                            ></path>
                            <path
                            d="M13.666 8.964c-.857-.236-1.356-.615-1.527-1.4 0-.095-.084-.172-.187-.172s-.187.077-.187.171c-.257.786-.67 1.244-1.528 1.401-.103 0-.187.077-.187.171 0 .095.084.172.187.172.857.235 1.357.614 1.528 1.4 0 .095.084.171.187.171s.187-.076.187-.171c.257-.786.67-1.243 1.527-1.4.104 0 .187-.077.187-.172 0-.094-.083-.171-.187-.171Z"
                            fill="url(#_3085173834__c)"
                            ></path>
                            <defs>
                            <linearGradient
                                id="_3085173834__a"
                                x1="-6.063"
                                y1="11.915"
                                x2="13.914"
                                y2="29.878"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#03A5AB"></stop>
                                <stop offset="1" stop-color="#8B3DFF"></stop>
                            </linearGradient>
                            <linearGradient
                                id="_3085173834__b"
                                x1="-6.063"
                                y1="11.915"
                                x2="13.914"
                                y2="29.878"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#03A5AB"></stop>
                                <stop offset="1" stop-color="#8B3DFF"></stop>
                            </linearGradient>
                            <linearGradient
                                id="_3085173834__c"
                                x1="-6.063"
                                y1="11.915"
                                x2="13.914"
                                y2="29.878"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#03A5AB"></stop>
                                <stop offset="1" stop-color="#8B3DFF"></stop>
                            </linearGradient>
                            </defs>
                        </svg>
                        </a>
                    </label>
                    </div>
                </form>
                </div>
            </div>
            <i class="noformobile">Hi {{$store.state.user.userInfo.name}}!</i>
            <div class="userboxpart" >
                <div class="icon"
                ><img
                    class="rounded img-fluid avatar-40"
                    :src="img_url + '' + $store.state.user.userInfo.user_image"
                    :alt="$store.state.user.userInfo.name"
                /></div>
                <h4>
                <i>{{ $store.state.user.userInfo.name }}</i>
                <p>{{ $store.state.user.userInfo.role_name }}</p>
                </h4>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="card-transparent homedashclassdO card-block card-stretch card-height mb-3">
                <div class="d-flex justify-content-between">
                    <div class="select-dropdown input-prepend input-append">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/" class="header-logo" exact>Home</router-link>
                                </li>
                                <li 
                                    class="breadcrumb-item active" 
                                    v-for="(item, index) in pathSegments" 
                                    :key="item.key"
                                    >
                                    <router-link
                                        :to="{
                                        path: '/folder',
                                            query: {
                                                path: getPathUpTo(index),
                                                aid: uidParam,
                                                mid: getMidUpTo(index),
                                            }
                                        }"
                                    >
                                        {{ item.value }}
                                    </router-link>
                                    </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <!-- Folder Start -->
        <div class="col-lg-12 mb-4"  v-if="tableLoader === 1 || tableLoader === 3">
            <div class="card m-0 p-0">
                <div class="card-header d-flex justify-content-between p-0 mb-3">
                    <div class="header-title">
                        <h4 class="card-title">Folders <span class="currentPaginationCls">(Currently viewing {{folderList.length}} of {{homeTotalFolder}} items)</span></h4>
                    </div>
                </div>
                <div class="folder_row d-flex w-100 flex-wrap">
                    <FolderName :myArray="folderList" />      
                    <div class="col-lg-12">     
                        <div v-if="homeFolderPage*$store.state.pageSize < homeTotalFolder" class="text-center mt-2 lmbtn">
                            <button
                                @click="loadFolderListingData(true)"
                                :disabled="$store.state.home.isHomeLoadingMore"
                                class="btn btn-primary btn-block"
                            >
                                {{ $store.state.home.isHomeLoadingMore ? 'Loading...' : 'Load More' }}
                            </button>
                        </div>          
                    </div> 
                </div>
            </div>
        </div>
        <div class="col-lg-12" v-if="tableLoader === 1">
            <div class="row" >
                <div class="col-md-6 col-sm-6 col-lg-3" v-for="index in 4" :key="index">
                    <div class="card card-block card-stretch card-height shimmer-card">
                        <div class="card-body">
                        <div class="d-flex justify-content-between">
                            <div class="icon-small bg-light shimmer rounded mb-4"></div>
                            <div class="dot shimmer rounded-circle"></div>
                        </div>
                        <div class="shimmer-line shimmer mb-2" style="width: 60%; height: 20px;"></div>
                        <div class="shimmer-line shimmer mb-2" style="width: 80%; height: 15px;"></div>
                        <div class="shimmer-line shimmer" style="width: 70%; height: 15px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Folder End -->
        <!-- Files Start -->
        <div class="col-lg-12" v-if="tableFileLoader === 1 || tableFileLoader === 3">
            <div class="card m-0 p-0">
                <div class="card-header d-flex justify-content-between p-0 mb-3">
                    <div class="header-title">
                        <h4 class="card-title">Files <span class="currentPaginationCls">(Currently viewing {{fileList.length}} of {{fileTotalCount}} items)</span></h4>                        
                    </div>
                </div>
                <div class="folder_row d-flex w-100 flex-wrap">
                    <FileName :myArray="fileList" />    
                    <div class="col-lg-12">     
                        <div v-if="currentPage*$store.state.pageSize < homeTotalFile" class="text-center mt-2 lmbtn">
                            <button
                                @click="loadFileListingData(true)"
                                :disabled="$store.state.home.isHomeImgLoadingMore"
                                class="btn btn-primary btn-block"
                            >
                                {{ $store.state.home.isHomeImgLoadingMore ? 'Loading...' : 'Load More' }}
                            </button>
                        </div>    
                    </div>  
                </div>  
            </div>
        </div>
        <div class="col-lg-12" v-if="tableFileLoader === 1">
            <div class="row" >
                <div class="col-md-6 col-sm-6 col-lg-3" v-for="index in 4" :key="index">
                    <div class="card card-block card-stretch card-height shimmer-card">
                        <div class="card-body">
                        <div class="d-flex justify-content-between">
                            <div class="icon-small bg-light shimmer rounded mb-4"></div>
                            <div class="dot shimmer rounded-circle"></div>
                        </div>
                        <div class="shimmer-line shimmer mb-2" style="width: 60%; height: 20px;"></div>
                        <div class="shimmer-line shimmer mb-2" style="width: 80%; height: 15px;"></div>
                        <div class="shimmer-line shimmer" style="width: 70%; height: 15px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12" v-if="tableFileLoader === 2 && tableLoader === 2">
            <div class="text-center">
                <ComponentNoData />
            </div>
        </div>
    </div>
    <DragDrop />
</template>
<script>
import axios from 'axios'
import FolderName from './FolderName.vue'
import FileName from './FileName.vue'
import ComponentNoData from '../Widgets/Icon/ComponentNoData.vue'
import DragDrop from './DragDrop.vue'
import {
    decodeTextFromBase62,
    encodeTextToBase62,
        startLoader,
        finishLoader
} from '../../utils/helper.js'
import 
    { post } 
from '../../utils/api.js'
export default {
    name: 'FolderIndexData',
    props: ['pathParam', 'fileParam'],
    components: {
        FolderName,
        FileName,
        ComponentNoData,
        DragDrop,
    },
    data() {
        return {
            folderName: '',
            img_url: process.env.VUE_APP_IMG_URL,
            pathSegments: [],
            midSegments: [],
            folderList: [],
            fileList: [],
            folderBcName: '',
            tableLoader: 1,
            tableFileLoader: 1,

            currentFilesPage: 1,
            currentPage: 1,
            pageSize: 2,
            homeFolderPage: 1,
            homeTotalFolder: 1,
            homeFilePage: 1,
            homeTotalFile: 1,
            totalPages: 1,
            isLoading: false,
            isLoadingMore: false,
            isLoadingFolderMore: false,
            uidParam: false,
            midParam: false,
            fileTotalCount: 0,
        }
    },
    mounted() {
        const result = [];
        const midResult = [];
        if (!this.pathParam || this.pathParam.trim() === '') {
            this.$router.push({
                name: 'Home',  // route name defined in router.js
            });
        } else {
            const pathParam = this.$route.query.path;
            const midParam = this.$route.query.mid;

            if (pathParam) {
                const pathSegments = pathParam.split('/');
                const midSegments = midParam.split('/');

                let newUrl = '';
                let newAxiosUrl = '';
                for (let i = 0; i < pathSegments.length; i++) {
                    let tempName = decodeTextFromBase62(pathSegments[i]);
                    let tempMidName = decodeTextFromBase62(midSegments[i]);
                    if( i === 0) {
                        newUrl = tempName;
                        newAxiosUrl = tempName;

                    } else{
                        newUrl = newUrl + '/' + tempName
                        newAxiosUrl = newAxiosUrl + '/' + tempName
                    }
                    result.push({
                        key: pathSegments[i],
                        value: tempName
                    });
                    midResult.push({
                        key: midSegments[i],
                        value: tempMidName
                    });
                }
                this.folderName = newAxiosUrl;
                this.folderBcName = newAxiosUrl;
            } else {
                this.folderName = decodeTextFromBase62(this.pathParam);
                this.folderBcName = decodeTextFromBase62(this.pathParam);
                
                result.push({
                    key: this.pathParam,
                    value:decodeTextFromBase62(this.pathParam)
                });
                midResult.push({
                    key: this.midParam,
                    value:decodeTextFromBase62(this.midParam)
                });
            }

            if (midParam) {
                const midSegments = midParam.split('/');
                const lastEncodedMid = midSegments[midSegments.length - 1];
                this.midParam = decodeTextFromBase62(lastEncodedMid);
            }
            this.pathSegments = result;
            this.midSegments = midResult;
        }
        this.loadFolderListingData();
        this.loadFileListingData();
    },
    computed: {
        iAT() {
            return this.$store.state.user.roleId
        },
        reFolderNew() {
            return this.$store.state.home.reLoadPathFolder
        },
        reLoad() {
            return this.$store.state.home.reLoadFoldercomponent
        },
        reLoadFile() {
            return this.$store.state.home.reLoadFilecomponent
        },
    },
    watch: {
        async iAT(newValue) {
            if (this.$store.state.user.roleId != '') {
                await this.loadFolderListingData();
                await this.loadFileListingData();
            }
            return newValue
        },
        async reFolderNew(newValue) {
            // await this.loadFolderListingData();
            return newValue
        },
        async reLoad(newValue) {
            const routeName = this.$route.name;
            if (routeName === 'Folder') {
                await this.reloadHomeFolder();
            }
            return newValue
        },
        async reLoadFile(newValue) {
            // await this.reloadHomeFolder();
            await this.reloadHomeFiles();
            // await this.reloadStarredFolder();
            // await this.reloadTrashFolder();
            return newValue
        },
    },
    methods: {
        encodeTextToBase62,
        startLoader,
        finishLoader,
        getPathUpTo(index) {
            // Collect keys up to the current index and join them
            return this.pathSegments
            .slice(0, index + 1)
            .map(item => item.key)
            .join('/');
        },
        getMidUpTo(index) {
            // Collect keys up to the current index and join them
            return this.midSegments
            .slice(0, index + 1)
            .map(item => item.key)
            .join('/');
        },
        async loadFolderListingData(loadMore = false) {
            try {
                if (!loadMore) {
                    // this.startLoader();
                    // this.fileList = [];
                    // this.currentFolderPage = 1;
                } else {
                    this.homeFolderPage += 1;
                    this.$store.state.home.isHomeLoadingMore = true;
                }
                this.startLoader();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                let _post = {}
                _post = {
                    folderName: this.folderName,
                    pageLength: this.$store.state.pageSize,
                    page: this.homeFolderPage,
                    // limit: 8,
                }
                let uidParam = localStorage.getItem("aid");
                if (uidParam) {
                    _post.user_id = uidParam;
                    this.uidParam = uidParam;
                    _post.folder_id = this.midParam
                }
                const resp = await post('files/list-folders', _post)
                if (resp.status == 200 && resp.data.status == 'success') {

                    const newFolders = resp.data.data.folders;

                    // Create a map to update or add folders uniquely by fullKey
                    const folderMap = new Map();

                    // First, add existing folders
                    this.folderList.forEach(folder => {
                    folderMap.set(folder.fullKey, folder);
                    });

                    // Then, overwrite or add new folders
                    newFolders.forEach(folder => {
                    folderMap.set(folder.fullKey, folder);
                    });

                    // Convert back to array
                    this.folderList = Array.from(folderMap.values());
                    
                    if (this.folderList.length > 0) {
                        this.tableLoader = 3
                    } else {
                        this.tableLoader = 2
                    }

                    // let totalCount = resp.data.data.totalFolders || 1;
                    // totalCount = totalCount / this.$store.state.pageSize;
                    // this.homeTotalFolder = totalCount;
                    this.homeTotalFolder = resp.data.data.totalFolders || 1;

                    this.finishLoader();
                    // this.loadFileListingData();
                    this.$store.state.home.isHomeLoadingMore = false;
                }
                
            } catch (error) {
                this.finishLoader();
                this.$store.state.home.isHomeLoadingMore = false;
                console.error('Error:', error.response?.data || error.message)
            }
        },

        async reloadHomeFolder() {
            try {
                this.startLoader();

                const psadaageSize = this.$store.state.pageSize * this.homeFolderPage
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                let _post = {}
                _post = {
                    folder_id: this.midParam,
                    folderName: this.folderName,
                    pageLength: psadaageSize,
                    page: 1,
                    test: 102,
                    // limit: 8,
                }
                const resp = await post('files/list-folders', _post)
                if (resp.status == 200 && resp.data.status == 'success') {
                    this.folderList = resp.data.data.folders;
                   
                    if (this.folderList.length > 0) {
                        this.tableLoader = 3
                    } else {
                        this.tableLoader = 2
                    }

                    // let totalCount = resp.data.data.totalFolders || 1;
                    // totalCount = totalCount / this.$store.state.pageSize;
                    // this.homeTotalFolder = totalCount;

                    this.homeTotalFolder = resp.data.data.totalFolders || 1;

                    this.finishLoader();
                    // this.loadFileListingData();
                }
                
            } catch (error) {
                this.finishLoader();
                console.error('Error:', error.response?.data || error.message)
            }
        },
        async reloadHomeFiles() {
            try {
                this.startLoader();

                const psadaageSize = this.$store.state.pageSize * this.currentFilesPage
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                let _post = {}
                _post = {
                    folderName: this.folderName,
                    pageLength: psadaageSize,
                    page: 1,
                    test: 1,
                    limit: this.currentFilesPage,
                    folder_id: this.midParam,
                }
                const resp = await post('files/list-files', _post)
                if (resp.status == 200 && resp.data.status == 'success') {
                    this.fileList = []
                    this.fileList = resp.data.data.files
                    this.fileTotalCount = resp.data.data.fileCount || 1;
                    this.homeTotalFile = resp.data.data.fileCount || 1;
                    if (this.fileList.length > 0) {
                        this.tableFileLoader = 3
                    } else {
                        this.tableFileLoader = 2
                    }

                    this.finishLoader();
                }
                
            } catch (error) {
                this.finishLoader();
                console.error('Error:', error.response?.data || error.message)
            }
        },
        async loadFileListingData(loadMore = false) {
            try {
                if (!loadMore) {
                    this.startLoader();
                    // this.fileList = [];
                    this.currentPage = 1;
                } else {
                    this.$store.state.home.isHomeImgLoadingMore = true;
                    this.currentPage += 1;
                }
                
                this.currentFilesPage = this.currentPage;
                axios.defaults.headers.common['Authorization'] =
                'Bearer ' + this.$store.state.user.accessToken;
                
                const _post = {
                    folderName: this.folderName,
                    pageLength: this.$store.state.pageSize,
                    page: this.currentPage,
                    folder_id: this.midParam,
                };
                const resp = await post('files/list-files', _post);

                if (resp.status === 200 && resp.data.status === 'success') {

                    const newFolders = resp.data.data.files;

                    // Create a map to update or add folders uniquely by fullKey
                    const folderMap = new Map();

                    // First, add existing folders
                    this.fileList.forEach(folder => {
                        folderMap.set(folder._id, folder);
                    });

                    // Then, overwrite or add new folders
                    newFolders.forEach(folder => {
                        folderMap.set(folder._id, folder);
                    });

                    // Convert back to array
                    this.fileList = Array.from(folderMap.values());
                    
                    if (this.fileList.length > 0) {
                        this.tableFileLoader = 3
                    } else {
                        this.tableFileLoader = 2
                    }

                    // let totalCount = resp.data.data.totalPages || 1;
                    // totalCount = totalCount / this.$store.state.pageSize;
                    // this.homeTotalFile = totalCount;

                    // this.homeTotalFile = resp.data.data.totalPages || 1;
                    
                    // let totalCount = resp.data.data.fileCount || 1;
                    // totalCount = totalCount / this.$store.state.pageSize;
                    // this.homeTotalFile = totalCount;
                    this.homeTotalFile = resp.data.data.fileCount || 1;
                    this.fileTotalCount = resp.data.data.fileCount || 1;

                    this.finishLoader();
                }
            } catch (error) {
                console.error('Error:', error.response?.data || error.message);
            } finally {
                this.finishLoader();
                this.$store.state.home.isHomeImgLoadingMore = false;
            }
        }
    },
}
</script>